// extracted by css-extract-rspack-plugin
export default {"listWrapper":"footer-fragment__PaymentMethods_listWrapper__p7pyM","sticky":"footer-fragment__PaymentMethods_sticky__JR1St","small":"footer-fragment__PaymentMethods_small__t7VEw"};